import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient"
import { PaginationResponse, ResponseData } from "../types/_public";
import { IChart, IGraphic, IParameter, ITemplate } from "../types/newshub/_template";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_templates = PATH_NEWSHUB_API + '/templates';
const path_variable = PATH_NEWSHUB_API + '/template-variables';
const path_chart = PATH_NEWSHUB_API + '/template-charts';

const templateApi = {
  templates(params: any): Promise<AxiosResponse<ResponseData<ITemplate[]> & PaginationResponse, any>> {
    const url = `${path_templates}`
    return api.get(url, params)
  },
  allTemplates(params: any = {}): Promise<AxiosResponse<ResponseData<ITemplate[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/templates`
    return api.get(url, params)
  },
  postTemplate(dataForm: any): Promise<AxiosResponse<ResponseData<ITemplate>, any>> {
    const url = `${path_templates}`;
    return api.post(url, dataForm)
  },
  putTemplate(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ITemplate>, any>> {
    const url = `${path_templates}/${id}`;
    return api.put(url, dataForm)
  },
  deleteTemplate(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ITemplate>, any>> {
    const url = `${path_templates}/${id}`;
    return api.delete(url, dataForm)
  },
  previewTemplate(dataForm: any): Promise<AxiosResponse<ResponseData<ITemplate>, any>> {
    const url = `${PATH_NEWSHUB_API}/news/preview`;
    return api.post(url, dataForm)
  },
  parameters(params: any): Promise<AxiosResponse<ResponseData<IParameter[]> & PaginationResponse, any>> {
    const url = `${path_variable}`
    return api.get(url, params)
  },
  allParameters(params: any): Promise<AxiosResponse<ResponseData<IParameter[]> & PaginationResponse, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/parameters`
    return api.get(url, params)
  },
  postParameter(dataForm: any): Promise<AxiosResponse<ResponseData<IParameter>, any>> {
    const url = `${path_variable}`;
    return api.post(url, dataForm)
  },
  putParameter(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IParameter>, any>> {
    const url = `${path_variable}/${id}`;
    return api.put(url, dataForm)
  },
  deleteParameter(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IParameter>, any>> {
    const url = `${path_variable}/${id}`;
    return api.delete(url, dataForm)
  },
  allCharts(params: any): Promise<AxiosResponse<ResponseData<IChart[]> & PaginationResponse, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/template-charts`
    return api.get(url, params)
  },
  postChart(dataForm: any): Promise<AxiosResponse<ResponseData<IChart>, any>> {
    const url = `${path_chart}`;
    return api.post(url, dataForm)
  },
  putChart(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IChart>, any>> {
    const url = `${path_chart}/${id}`;
    return api.put(url, dataForm)
  },
  deleteChart(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IChart>, any>> {
    const url = `${path_chart}/${id}`;
    return api.delete(url, dataForm)
  },
  graphics(params: any): Promise<AxiosResponse<ResponseData<IGraphic[]> & PaginationResponse, any>> {
    const url = `${path_chart}`
    return api.get(url, params)
  },
  postGraphic(dataForm: any): Promise<AxiosResponse<ResponseData<IGraphic>, any>> {
    const url = `${path_chart}`;
    return api.post(url, dataForm)
  },
  putGraphic(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IGraphic>, any>> {
    const url = `${path_chart}/${id}`;
    return api.put(url, dataForm)
  },
  deleteGraphic(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IGraphic>, any>> {
    const url = `${path_chart}/${id}`;
    return api.delete(url, dataForm)
  },
}
export default templateApi
